export const GROUPING_METHOD = {
	DAILY: 'day',
	WEEKLY: 'week',
	MONTHLY: 'month'
}

export const COMPARISON_TYPE = {
	MORE: 'more expensive',
	LESS: 'cheaper',
	EQUAL: 'equal',
}

export const TABLE_OPTION = {
	MIN: 'min',
	MAX: 'max',
	AVG: 'avg'
}